export default __webpack_public_path__ + "static/media/Error404.694b4357.png";